import { Component, Inject } from '@angular/core';
import { RestAPIService } from 'src/app/services/restapi.service';
import { environment } from 'src/environments/environment';
import {FormControl, Validators} from '@angular/forms';
import { ConfigurationModel, AddConfigurationMatrixModel } from 'src/app/components/configuration/models/configurationModel';
import { ConfigurationGroupModel } from 'src/app/components/configuration/models/configurationGroupModel';
import { ConfigurationTypeModel } from 'src/app/components/configuration/models/configurationTypeModel';
import { ConfigurationSearchModel } from 'src/app/components/configuration/models/configurationSearchModel';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-add-configuration',
  templateUrl: './configuraton.add.component.html'
})
export class AddConfigurationComponent {
    submitted: boolean = false;
    configurationByTypesList: ConfigurationModel[] = [];
    configurationGroupList: ConfigurationGroupModel[] = [];
    configurationTypeList: ConfigurationTypeModel[] = [];
    configurationModel: ConfigurationModel = new ConfigurationModel();
    configurationSearchModel: ConfigurationSearchModel = new ConfigurationSearchModel();
    singleConfigurationTypeCode = "S";
    matrixConfigurationTypeCode = "M";
    searchConfigurationTypes = "L,R";
    productCode!: string;
    groupId = new FormControl('', [Validators.required]);
    configKey = new FormControl('', [Validators.required]);
    configurationTypeCode = new FormControl('', [Validators.required]);
    condition1 = new FormControl('', [Validators.required]);
    

    constructor(public _restAPI: RestAPIService, public dialogRef: MatDialogRef<AddConfigurationComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        @Inject(MAT_DIALOG_DATA) public productCodeData: string) {  
            this._restAPI.loading  = false;
            this.configurationModel = data.configuration;
            this.configurationModel.addConfigurationMatrixModel = new AddConfigurationMatrixModel(); 
            this.productCode = data.productCodeData;             
    }

    async ngOnInit() {
        await this.getConfigurationGroupList();
        await this.getConfigurationTypeList();
        await this.getConfigurationByTypeList();
    }

    closeDialog(): void {
        this.dialogRef.close(false);
    }

    async getConfigurationByTypeList() {
        this._restAPI.loading  = true;
        this._restAPI.get<ConfigurationModel[]>(environment.apiURL + 'api/configuration/' + this.productCode + '/configurationType/L,M').subscribe({
            next: (data) => {
                this._restAPI.loading  = false;
                this.configurationByTypesList = data;
            },
            error: (error) => {this._restAPI.loading  = false; console.error(error)}
        });
    }

    async getConfigurationGroupList() {
        this._restAPI.loading  = true;
        this._restAPI.get<ConfigurationGroupModel[]>(environment.apiURL + 'api/configuration/' + this.productCode + '/group').subscribe({
            next: (data) => {
                this._restAPI.loading  = false;
                this.configurationGroupList = data;
            },
            error: (error) => {this._restAPI.loading  = false;console.error(error)}
        });
    }
    
    async getConfigurationTypeList() {
        this._restAPI.loading  = true;
        this._restAPI.get<ConfigurationTypeModel[]>(environment.apiURL + 'api/configuration/' + this.productCode + '/type').subscribe({
            next: (data) => {
                this._restAPI.loading  = false;
                this.configurationTypeList = data;
            },
            error: (error) => {this._restAPI.loading  = false; console.error(error)}
        });
    }

    async saveConfiguration() {
        this.submitted = true;
        if(!this.groupId.invalid && !this.configKey.invalid && !this.configurationTypeCode.invalid &&
            (this.configurationModel.configurationTypeCode != this.matrixConfigurationTypeCode || (!this.condition1.invalid) )){
            let postData = {};
            if (this.configurationModel.configurationTypeCode != this.matrixConfigurationTypeCode) {
                postData = {
                    configurationId: this.configurationModel.configurationId,
                    groupId: this.configurationModel.groupId,
                    productCode: this.configurationModel.productCode,
                    configKey: this.configurationModel.configKey,
                    value: this.configurationModel.value,
                    name: this.configurationModel.name,
                    configurationTypeCode: this.configurationModel.configurationTypeCode,
                    description: this.configurationModel.description,
                    isActive: this.configurationModel.isActive
                };
            }
            else {
                postData = {
                    configurationId: this.configurationModel.configurationId,
                    groupId: this.configurationModel.groupId,
                    productCode: this.configurationModel.productCode,
                    configKey: this.configurationModel.configKey,
                    value: this.configurationModel.value,
                    name: this.configurationModel.name,
                    configurationTypeCode: this.configurationModel.configurationTypeCode,
                    description: this.configurationModel.description,
                    isActive: this.configurationModel.isActive,
                    addConfigurationMatrixModel: this.configurationModel.addConfigurationMatrixModel
                };
            }
            this._restAPI.loading  = true;
            this._restAPI.post<string>(environment.apiURL + 'api/configuration/' + this.productCode, postData).subscribe({
                next: (data) => {
                    this._restAPI.loading  = false;
                    this.submitted = false;
                    this.dialogRef.close(true);
                },
                error: (error) => {this._restAPI.loading  = false;console.error(error)}
            });
        }
    }

    onTypeChange() {
        if (this.configurationModel.configurationTypeCode != this.matrixConfigurationTypeCode) {
            this.configurationModel.addConfigurationMatrixModel.condition1 = null;
            this.onConditionChange();
        }
    }

    onConditionChange() {
        if (this.configurationModel.addConfigurationMatrixModel.condition1 == null || this.configurationModel.addConfigurationMatrixModel.condition1.length <= 0) {
            this.configurationModel.addConfigurationMatrixModel.condition2 = null;      
        }

        if (this.configurationModel.addConfigurationMatrixModel.condition2 == null || this.configurationModel.addConfigurationMatrixModel.condition2.length <= 0) {
            this.configurationModel.addConfigurationMatrixModel.condition3 = null;      
        }

        if (this.configurationModel.addConfigurationMatrixModel.condition3 == null || this.configurationModel.addConfigurationMatrixModel.condition3.length <= 0) {
            this.configurationModel.addConfigurationMatrixModel.condition4 = null;      
        }

        if (this.configurationModel.addConfigurationMatrixModel.condition4 == null || this.configurationModel.addConfigurationMatrixModel.condition4.length <= 0) {
            this.configurationModel.addConfigurationMatrixModel.condition5 = null;      
        }
    }
}
